import { baseApi } from "@/shared/api";
import type { DashboardSummaryResponse, DashboardSummaryParams } from "../types";

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardSummary: builder.query<DashboardSummaryResponse, DashboardSummaryParams>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        searchParams.set("year", String(params.year));
        if (params.month !== undefined) searchParams.set("month", String(params.month));
        if (params.project_id !== undefined) searchParams.set("project_id", String(params.project_id));
        if (params.status_filter) searchParams.set("status_filter", params.status_filter);
        return {
          url: `/api/accounting/dashboard/summary/?${searchParams.toString()}`,
          method: "GET",
          credentials: "include" as const,
        };
      },
      providesTags: [
        { type: "Reports" as const, id: "DASHBOARD_SUMMARY" },
        { type: "Reports" as const, id: "LIST" },
        "SmetaData",
        "IncomeRecords",
      ],
    }),
  }),
});

export const { useGetDashboardSummaryQuery } = dashboardApi;
